// Show Schedule Configuration - PlayFM Dublin
// Source: https://playfmdublin.com/shows-schedule/
// Live Shows Only (Play Show Replays excluded)
export const SHOWS = [
  // Monday Shows
  {
    id: 'turned-on',
    name: 'Turned On',
    startTime: '17:00',
    endTime: '18:00',
    days: ['Monday'],
    genre: 'House',
    host: 'Ben Gomori'
  },
  {
    id: 'sekora-radio',
    name: 'Sekora Radio',
    startTime: '18:00',
    endTime: '19:00',
    days: ['Monday'],
    genre: 'Deep House',
    host: 'UOAK'
  },
  {
    id: 'i-am-house-radio',
    name: 'I Am House Radio',
    startTime: '19:00',
    endTime: '20:00',
    days: ['Monday'],
    genre: 'House',
    host: 'Crystal Waters'
  },
  {
    id: 'caution-show',
    name: 'Caution Show (Bi-Weekly)',
    startTime: '20:00',
    endTime: '21:00',
    days: ['Monday'],
    genre: 'Drum N Bass',
    host: 'Polska'
  },
  {
    id: 'ugenius-radio',
    name: 'UGENIUS Radio',
    startTime: '21:00',
    endTime: '22:00',
    days: ['Monday'],
    genre: 'Melodic Techno'
  },
  {
    id: 'abracadabra-radio',
    name: 'Abracadabra Radio',
    startTime: '22:00',
    endTime: '23:00',
    days: ['Monday'],
    genre: 'Deep House',
    host: 'Blond:ish'
  },
  {
    id: 'dublin-street-speakers',
    name: 'Dublin Street Speakers',
    startTime: '23:00',
    endTime: '24:00',
    days: ['Monday'],
    genre: 'Techno',
    host: 'AyJay'
  },
  
  // Tuesday Shows
  {
    id: 'ibiza-sensations',
    name: 'Ibiza Sensations',
    startTime: '16:00',
    endTime: '17:00',
    days: ['Tuesday'],
    genre: 'Deep House',
    host: 'Luis del Villar'
  },
  {
    id: 'traxsource-live',
    name: 'Traxsource Live',
    startTime: '17:00',
    endTime: '18:00',
    days: ['Tuesday'],
    genre: 'Deep House'
  },
  {
    id: 'glasgow-underground-radio',
    name: 'Glasgow Underground Radio',
    startTime: '18:00',
    endTime: '19:00',
    days: ['Tuesday'],
    genre: 'Deep House',
    host: 'Kevin McKay'
  },
  {
    id: 'clapcast',
    name: 'Clapcast',
    startTime: '19:00',
    endTime: '20:00',
    days: ['Tuesday'],
    genre: 'House',
    host: 'Claptone'
  },
  {
    id: 'the-sound-selection',
    name: 'The Sound Selection',
    startTime: '20:00',
    endTime: '22:00',
    days: ['Tuesday'],
    genre: 'Nu Disco',
    host: 'Del Fortune'
  },
  {
    id: 'portals',
    name: 'Portals',
    startTime: '22:00',
    endTime: '23:00',
    days: ['Tuesday'],
    genre: 'Drum N Bass',
    host: 'Robert O\'Brien'
  },
  {
    id: 'the-ultimate-playlist',
    name: 'The Ultimate Playlist',
    startTime: '23:00',
    endTime: '24:00',
    days: ['Tuesday'],
    genre: 'House',
    host: 'Eskay'
  },
  
  // Wednesday Shows
  {
    id: 'vonyc-sessions',
    name: 'Vonyc Sessions',
    startTime: '00:00',
    endTime: '02:00',
    days: ['Wednesday'],
    genre: 'Trance',
    host: 'Paul Van Dyk'
  },
  {
    id: 'elevated-radio',
    name: 'Elevated Radio',
    startTime: '15:00',
    endTime: '16:00',
    days: ['Wednesday'],
    genre: 'Tech House',
    host: 'Salvione'
  },
  {
    id: 'midweek-mixtape',
    name: 'Midweek Mixtape',
    startTime: '16:00',
    endTime: '17:00',
    days: ['Wednesday'],
    genre: 'Disco',
    host: 'Em i6'
  },
  {
    id: 'defected-radio',
    name: 'Defected Radio',
    startTime: '17:00',
    endTime: '19:00',
    days: ['Wednesday'],
    genre: 'House'
  },
  {
    id: 'set-the-mood',
    name: 'Set The Mood',
    startTime: '19:00',
    endTime: '20:00',
    days: ['Wednesday'],
    genre: 'House',
    host: 'DO\'R'
  },
  {
    id: 'toolroom-radio',
    name: 'Toolroom Radio',
    startTime: '20:00',
    endTime: '22:00',
    days: ['Wednesday'],
    genre: 'Tech House',
    host: 'Mark Knight'
  },
  {
    id: 'select',
    name: 'Select',
    startTime: '22:00',
    endTime: '23:00',
    days: ['Wednesday'],
    genre: 'Tech House',
    host: 'John Power'
  },
  {
    id: 'selected-sessions',
    name: 'Selected Sessions',
    startTime: '23:00',
    endTime: '24:00',
    days: ['Wednesday'],
    genre: 'House'
  },
  
  // Thursday Shows
  {
    id: 'the-abstrait-sessions',
    name: 'The Abstrait Sessions',
    startTime: '10:00',
    endTime: '12:00',
    days: ['Thursday'],
    genre: 'Chillout',
    host: 'Raphael Marionneau'
  },
  {
    id: 'the-o-sessions',
    name: 'The O Sessions',
    startTime: '17:00',
    endTime: '18:00',
    days: ['Thursday'],
    genre: 'Progressive House',
    host: 'Claudia O'
  },
  {
    id: 'the-art-of-sound',
    name: 'The Art Of Sound',
    startTime: '18:00',
    endTime: '19:00',
    days: ['Thursday'],
    genre: 'Electronica',
    host: 'Rory Lester'
  },
  {
    id: 'sonic-pleasures',
    name: 'Sonic Pleasures',
    startTime: '19:00',
    endTime: '20:00',
    days: ['Thursday'],
    genre: 'Funk & Soul',
    host: 'Simon O\'Brien'
  },
  {
    id: 'adesso-music-radio-show',
    name: 'Adesso Music Radio Show',
    startTime: '20:00',
    endTime: '21:00',
    days: ['Thursday'],
    genre: 'Jackin House',
    host: 'Junior Jack'
  },
  {
    id: 'odd-one-out-radio',
    name: 'Odd One Out Radio',
    startTime: '21:00',
    endTime: '22:00',
    days: ['Thursday'],
    genre: 'Organic House',
    host: 'Yotto'
  },
  {
    id: 'enhanced-sessions',
    name: 'Enhanced Sessions',
    startTime: '22:00',
    endTime: '24:00',
    days: ['Thursday'],
    genre: 'Trance',
    host: 'Farius'
  },
  
  // Friday Shows
  {
    id: 'music-for-dreams',
    name: 'Music For Dreams',
    startTime: '13:00',
    endTime: '14:00',
    days: ['Friday'],
    genre: 'Balearic',
    host: 'Kenneth Bager'
  },
  {
    id: 'hed-kandi-radio',
    name: 'Hed Kandi Radio',
    startTime: '16:00',
    endTime: '18:00',
    days: ['Friday'],
    genre: 'House'
  },
  {
    id: 'glitterbox-radio-show',
    name: 'Glitterbox Radio Show',
    startTime: '18:00',
    endTime: '19:00',
    days: ['Friday'],
    genre: 'Disco'
  },
  {
    id: 'the-audio-files',
    name: 'The Audio Files',
    startTime: '19:00',
    endTime: '20:00',
    days: ['Friday'],
    genre: 'Organic House',
    host: 'Karl Lambert'
  },
  {
    id: 'group-therapy',
    name: 'Group Therapy',
    startTime: '20:00',
    endTime: '22:00',
    days: ['Friday'],
    genre: 'House',
    host: 'Above & Beyond'
  },
  {
    id: 'circoloco-radio',
    name: 'CircoLoco Radio',
    startTime: '22:00',
    endTime: '23:00',
    days: ['Friday'],
    genre: 'Tech House'
  },
  {
    id: 'casa-misolarec',
    name: 'Casa Misolarec',
    startTime: '23:00',
    endTime: '24:00',
    days: ['Friday'],
    genre: 'Techno',
    host: 'Marino Rispo'
  },
  
  // Saturday Shows
  {
    id: 'guidos-lounge-cafe',
    name: 'Guido\'s Lounge Cafe',
    startTime: '10:00',
    endTime: '11:00',
    days: ['Saturday'],
    genre: 'Chillout'
  },
  {
    id: 'flow-radio-show',
    name: 'Flow Radio Show',
    startTime: '15:00',
    endTime: '16:00',
    days: ['Saturday'],
    genre: 'Deep House',
    host: 'Franky Rizardo'
  },
  {
    id: 'phuture-phunk',
    name: 'Phuture Phunk',
    startTime: '16:00',
    endTime: '18:00',
    days: ['Saturday'],
    genre: 'House',
    host: 'Paul Dolan'
  },
  {
    id: 'long-live-house-radio',
    name: 'The Long Live House Radio Show',
    startTime: '18:00',
    endTime: '20:00',
    days: ['Saturday'],
    genre: 'Disco',
    host: 'Graeme Park'
  },
  {
    id: 'back-to-mine-radio',
    name: 'Back To Mine Radio',
    startTime: '20:00',
    endTime: '21:00',
    days: ['Saturday'],
    genre: 'House',
    host: 'Ronan O'
  },
  {
    id: 'in-session',
    name: 'In Session',
    startTime: '21:00',
    endTime: '22:00',
    days: ['Saturday'],
    genre: 'Tech House',
    host: 'Sister Bliss'
  },
  {
    id: 'dialekt-radio',
    name: 'Dialekt Radio',
    startTime: '22:00',
    endTime: '23:00',
    days: ['Saturday'],
    genre: 'Progressive House',
    host: 'Sultan & Shepard'
  },
  {
    id: 'cadenza-radio',
    name: 'Cadenza Radio',
    startTime: '23:00',
    endTime: '24:00',
    days: ['Saturday'],
    genre: 'Deep House',
    host: 'Luciano'
  },
  
  // Sunday Shows
  {
    id: 'melodica',
    name: 'Melodica',
    startTime: '10:00',
    endTime: '11:00',
    days: ['Sunday'],
    genre: 'Chillout',
    host: 'Chris Coco'
  },
  {
    id: 'sunsets',
    name: 'Sun:sets',
    startTime: '11:00',
    endTime: '12:00',
    days: ['Sunday'],
    genre: 'Chillout',
    host: 'Chicane'
  },
  {
    id: 'darklight-sessions',
    name: 'Darklight Sessions',
    startTime: '15:00',
    endTime: '16:00',
    days: ['Sunday'],
    genre: 'House',
    host: 'Fedde Le Grand'
  },
  {
    id: 'discoteca',
    name: 'Discoteca',
    startTime: '16:00',
    endTime: '18:00',
    days: ['Sunday'],
    genre: 'Disco',
    host: 'Barry Dempsey'
  },
  {
    id: 'the-groove-project',
    name: 'The Groove Project',
    startTime: '18:00',
    endTime: '20:00',
    days: ['Sunday'],
    genre: 'Deep House',
    host: 'Andrew Gormley'
  },
  {
    id: 'the-peoples-choice',
    name: 'The People\'s Choice (Bi-Weekly)',
    startTime: '20:00',
    endTime: '22:00',
    days: ['Sunday'],
    genre: 'Reggae',
    host: 'Reggae Richie'
  },
  {
    id: 'bootlegs-and-bsides',
    name: 'Bootlegs & B-Sides',
    startTime: '22:00',
    endTime: '23:00',
    days: ['Sunday'],
    genre: 'Funk & Soul',
    host: 'Doe Ran'
  },
  {
    id: 'sonar-bliss',
    name: 'Sonar Bliss',
    startTime: '23:00',
    endTime: '02:00',
    days: ['Sunday'],
    genre: 'Deep House',
    host: 'Tony Walls & Suggzy'
  }
];

export const getShowById = (id) => {
  return SHOWS.find(show => show.id === id);
};

export const getShowsForDay = (dayName) => {
  return SHOWS.filter(show => show.days.includes(dayName));
};

